// src/main.js
/* eslint-disable no-console */

// Polyfills لدعم المتصفحات القديمة
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axiosPlugin from './plugins/axios'

// أنماط عامة
import './assets/styles/global.css'
import './assets/styles/quiz.css'

// توليد UUID للجهاز مع fallback
const DEVICE_KEY = 'device_uuid'
if (!localStorage.getItem(DEVICE_KEY)) {
  const uuid = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
  localStorage.setItem(DEVICE_KEY, uuid)
}

// إنشاء التطبيق
const app = createApp(App)

// حدث PWA (beforeinstallprompt)
let deferredPrompt = null
window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault()
  deferredPrompt = e
  app.config.globalProperties.$deferredPrompt = deferredPrompt
})

// تركيب الإضافات
app.use(router)
app.use(axiosPlugin, {
  deviceId: localStorage.getItem(DEVICE_KEY)
})

// devTools
app.config.devtools = process.env.NODE_ENV !== 'production'

// ✅ تسجيل Service Worker مع تحديث إجباري
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(registration => {
      console.log('✅ Service Worker registered:', registration)

      // عندما تُكتشف نسخة جديدة من SW
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (!installingWorker) return

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // نسخة جديدة متاحة — نفّذ التحديث الإجباري
              console.log('🔄 New content is available; refreshing now...')
              registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
              // إعادة تحميل الصفحة فورًا
              window.location.reload()
            } else {
              console.log('📦 Content cached for offline use.')
            }
          } else if (installingWorker.state === 'redundant') {
            console.warn('⚠️ The installing service worker became redundant.')
          }
        }
      }
    })
    .catch(err => {
      console.error('❌ Error during service worker registration:', err)
    })

  // التعامل مع وضع عدم الاتصال
  window.addEventListener('offline', () => {
    console.log('🌐 No internet connection found. App is running in offline mode.')
  })
} else {
  console.warn('⚠️ Service Worker not supported in this browser.')
}

// تشغيل التطبيق
app.mount('#app')
